export const tokenAddresses = {
  EUL: "0x2117E8b79e8E176A670c9fCf945d4348556bfFad",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x5e13d41913aDF18bb2acAe34228E8D21f3c2f2Eb",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
